import Vue from 'vue'

const state = {
  productionOutputs: {}
}

const mutations = {
  SET_PRODUCTION_OUTPUTS (state, productionOutputs) {
    state.productionOutputs = productionOutputs
  }
}

const actions = {
  fetchProductionOutputs: ({commit}) => {
    return Vue.prototype.$axios.get('production-outputs/')
      .then(response => {
        commit('SET_PRODUCTION_OUTPUTS', response.data)
      })
  }
}

const getters = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
